var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 60",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38,5H26a5,5,0,0,0-5,5v6h2V10a3,3,0,0,1,3-3H38a3,3,0,0,1,3,3V38a3,3,0,0,1-3,3H26a3,3,0,0,1-3-3V32H21v6a5,5,0,0,0,5,5H38a5,5,0,0,0,5-5V10A5,5,0,0,0,38,5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36,25V23H8.41l6.3-6.29-1.42-1.42-8,8a1,1,0,0,0-.21,1.09.91.91,0,0,0,.22.32h0l8,8,1.42-1.42L8.41,25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.2f800b76081605d2b47b691344635893.svg";
export { ForwardRef as ReactComponent };